{
  "allRequired": "All fields must be filled out",
  "requiredField": "Required",
  "optional": "Optional",
  "allOptional": "All fields are optional",
  "requiredRadiobuttonList": "Select one",
  "requiredCheckboxList": "Select one or more",
  "requiredSingleCheckbox": "Must be selected"
}
